<template>
  <section
    id="media"
    class="co-bg-striped px-5 py-20"
  >
    <div class="co-container-lg">
      <h2 class="co-heading-2-caption mb-6 text-center">
        メディア掲載
      </h2>
      <div class="mb-12 text-center text-co-gray-600">
        日本経済新聞、マイナビなどで紹介されています
      </div>
      <div class="mb-5 flex flex-col items-center justify-center gap-4 sm:flex-row lg:gap-10">
        <div>
          <img
            src="~/assets/images/Te/TeCourse/Ordermade/Media/media-newspaper.webp"
            width="430"
            height="242"
            class="w-full md:w-auto"
            loading="lazy"
            alt="日本経済新聞"
          >
        </div>
        <div>
          <img
            src="~/assets/images/Te/TeCourse/Ordermade/Media/media-site.webp"
            width="430"
            height="242"
            class="w-full md:w-auto"
            loading="lazy"
            alt="マイナビニュース"
          >
        </div>
      </div>
      <ul class="co-display-11 flex flex-wrap justify-center gap-5 font-bold text-co-gray-500 md:gap-7">
        <li>NHK</li>
        <li>産経</li>
        <li>WBS</li>
        <li>東洋経済</li>
        <li>NEWSPICKS</li>
        <li>フォーブス</li>
      </ul>
    </div>
  </section>
</template>
